import {useEffect, useState} from 'react';

export const useInAppBrowserDetector = () => {
    const [isInAppBrowser, setIsInAppBrowser] = useState<boolean>(false);

    useEffect(() => {
        // Ensure we are in a browser environment (important if using Next.js)
        if (typeof window === 'undefined') return;

        const ua = navigator.userAgent;

        // Check for Facebook and Instagram user agents
        const isFacebook = ua.indexOf('FBAV') > -1 || ua.indexOf('FBAN') > -1;
        const isInstagram = ua.indexOf('Instagram') > -1;

        if (isFacebook || isInstagram) {
            setIsInAppBrowser(true);
        }

    }, [window?.navigator?.userAgent]);

    return {
        isInAppBrowser
    };
}

